import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import {finalize, Observable, of, retry, throwError, timer} from 'rxjs';
import {catchError} from "rxjs/operators";
import {Handle500dialogComponent} from "../components/handle500dialog/handle500dialog.component";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";

@Injectable()
export class RetryInterceptor implements HttpInterceptor {

  private _retryDialogRef: MatDialogRef<Handle500dialogComponent> | null = null;

  constructor(
    private readonly dialog: MatDialog
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request)
      .pipe(
        retry({count: 2, resetOnSuccess: false, delay: (error, count) => {
            if(error?.status >= 500) {
              if(count === 1) { console.error(error); }
              return timer(2000)
            } else {
              return throwError(error)
            }
          }}),
        catchError((error) => {
          console.dir(error)
           if(error.status >= 500) {
             if(!this._retryDialogRef) {
               this._retryDialogRef = this.dialog.open(Handle500dialogComponent, {
                 minWidth: '25rem',
                 height: '20rem',
                 maxWidth: '31rem',
                 maxHeight: '20rem',
                 panelClass: 'dialog-radius'
               })
               this._retryDialogRef.afterClosed()
                 .pipe(finalize(() => this._retryDialogRef = null))
             }
             return throwError(() => new Error('Не удалось загрузить данные с сервера'));
           } else {
             return throwError(error);
           }
        }),
      );
  }
}
